<template>
	<div class="downloads">
		<banner title="联系我们" :img="sty" />
		<div class="contact_div">
			<div class="nav_1">
				<div class="afferp"></div>
				<p class="contact_p1">CONTACT INFORMATION</p>
				<p class="contact_p2">FIND US 联系方式</p>
			</div>
		</div>
		<div>
			<div class="contact_img">
				<div v-for="(item, index) in list" :key="index">
					<div class="c_imng"><img :src="item.img" alt="" /></div>
					<div class="c_div">
						<p class="c_p1">{{ item.p1 }}</p>
						<p class="c_a"></p>
						<p class="c_p2">{{ item.p2 }}</p>
					</div>
				</div>
			</div>
		</div>
		<div style="width:100%;height:35vh">
			<maps />
		</div>
		<div class="contact_div">
			<div class="nav_1">
				<div class="afferp"></div>
				<p class="contact_p1">LEAVE A MESSAGE</p>
				<p class="contact_p2">FIND US 意向留言</p>
			</div>
		</div>
		<div class="c_form">
			<el-input placeholder="手机Phone" v-model="form.phone"></el-input>
			<el-input placeholder="邮箱E-mail" v-model="form.email"></el-input>
		</div>
		<div class="c_fom1">
			<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10 }" placeholder="请输入内容" v-model="form.descp">
			</el-input>
			<el-button style="width:100px;margin-top:20px" @click="handelClickSubMit">提交</el-button>
		</div>
	</div>
</template>

<script>
	import maps from "@/components/map";
	import Banner from "../components/Banner";
	export default {
		components: {
			Banner,
			maps,
		},
		data() {
			return {
				form: {
					descp: "",
					phone: "",
					email: "",
					wechat: '',
					doinflag: ''
				},
				textarea2: "",
				list: [],
				sty: {
					// backgroundImage: "url(" + require("@/assets/home/banner4.png") + ")",
				},
			};
		},
		mounted(){
			this.getData();
			this.getlunbo()
		},
		methods: {
			getlunbo() {
				var that = this;
				that.$axios({
					method: "get",
					url: "system/pcmanage/list",
					// data: this.$qs.stringify(data)
					params: {
						location:6
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if(res.data.result == 200){
						console.log(res.data)
						var data = res.data.detail;
						that.sty = {
							backgroundImage: "url(" + data[0].showpath + ")",
						}
					}
					
				})
			},
			getData(){
				var that = this;
				that.$axios({
					method: "get",
					url: "webpc/pcmastercompany/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						that.list = [{
								img: require("@/assets/home/ico1.png"),
								p1: "电话",
								p2: data.company_phone,
							},
							{
								img: require("@/assets/home/ico2.png"),
								p1: "邮箱",
								p2: data.email,
							},
							{
								img: require("@/assets/home/ico3.png"),
								p1: "地址",
								p2: data.address,
							},

						];
					}
				
				})
			},
			handelClickSubMit() {
				var that = this;
				
				// if(that.msg.name.trim() == ''){
				// 	that.$message.error("请填写姓名");
				// 	return;
				// }
				if (that.form.phone.trim() == '') {
					that.$message.error("请填写手机");
					return;
				}
				if (that.form.email.trim() == '') {
					that.$message.error("请填写邮箱");
					return;
				}
				if (that.form.descp.trim() == '') {
					that.$message.error("请填写内容");
					return;
				}
				that.loading1 = true;
				that.$axios({
					method: "post",
					url: "webpc/pconlinemessage/list",
					// data: this.$qs.stringify(data)
					params: {
						email: that.form.email,
						descp: that.form.descp,
						type: 1,
						phone: that.form.phone
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					var data = res.data.data;
					that.loading1 = false;
					if (res.data.result == 200) {
						that.$message({
							message: '提交成功',
							type: 'success'
						});
						that.form.email = '';
						that.form.descp = '';
						that.form.phone = '';
						// var data = result.data.data;
						// that.zhengshu = [];
						// for(var i = 0;i<data.length;i++){
						// 	that.zhengshu.push({
						// 		tu:data[i].attas[0].path
						// 	});
						// }
				
					}
				})
				// this.$http
				// 	.post("/system/pconlinemessage/add", this.form)
				// 	.then((res) => {
				// 		this.$message.success("意见反馈成功");
				// 	});
			},
			// handelClickSubMit() {
			//   //提交按钮
			//   this.$message.error("您还没有登录，请登陆后提交");
			// },
		},
	};
</script>

<style lang="scss" scoped>
	.c_div {
		display: grid;
		place-items: center;
	}

	.downloads {
		background: #fff;

		.contact_div {
			width: 50%;
			height: 15vh;

			margin: 20px auto;
			text-align: center;
			display: grid;
			place-items: center;

			.nav_1 {
				display: grid;
				place-items: center;

				.afferp {
					width: 50px;

					height: 2px;
					background: #272727;
				}

				.contact_p1 {
					height: 50%;
					font-size: 30px;
					font-family: Arial;

					color: #272727;
				}

				.contact_p2 {
					margin-top: 20px;
					font-size: 18px;
					font-family: Arial;

					color: #272727;
				}
			}
		}

		.contact_img {
			width: 40%;
			height: 35vh;
			display: grid;
			margin: auto;
			grid-template-columns: 1fr 1fr 1fr;
			grid-column-gap: 40px;
			grid-template-rows: 1fr 1fr;

			.c_p1 {
				margin-top: 10px;
				font-size: 18px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #545454;
				text-align: center;
			}

			.c_a {
				width: 50%;
				margin: 10px 0;
				text-align: center;
				height: 1px;
				background: #545454;
			}

			.c_p2 {
				text-align: center;
				font-size: 16px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #545454;
			}

			.c_imng {
				display: grid;
				place-items: center;

				img {
					width: 70%;
				}
			}
		}

		.c_form {
			width: 50%;
			display: grid;
			margin: auto;
			grid-column-gap: 40px;

			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr 1fr;
			grid-row-gap: 20px;
		}

		.c_fom1 {
			width: 50%;
			height: 100%;

			display: grid;
			margin: 20px auto;

			place-items: center;
		}
	}

	::v-deep.el-input__inner {
		background: #fff;
		border: none;
		border-bottom: 1px solid #dcdfe6;
	}

	::v-deep.el-textarea__inner {
		background: #fff;
	}
</style>
